import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import DrawerNavGroups from './DrawerNavGroups';
import { getFilterContext, FILTER_CONTEXTS, isEcosystemContext } from './filterContext';
import { getCurrentElakayRole } from '../../includes/pageInside/Rolle';
import { useDrawerFilters, consumeFilterFocus } from './drawerFilterSlot';
import Filter from '../../includes/pageInside/Filter_fitlerP';
import FiltersSU from '../../includes/pageInside/Filter_fitlerSU';
import FilterUserProduct from "../../includes/pageInside/filterUserProduct";
import './SideDrawer1.css';
import { elakayAutoText } from "../../includes/pageInside/dataElakay";
import { CARD_MODE_STORAGE_KEY, CARD_MODE_EVENT } from "../../utils/cardDisplaySettings";
import { MdClose, MdInventory2 } from "react-icons/md";


const SideDrawer1 = ({
  show,
  infoSource,
  SliderPunShow,
  categoriesID,
  handleFilters,
  prices,
  loadProductsBySell,
  setMyFilters,
  AllCategorie,
  filterShop = false,
  setFilterShop,
  userShop,
  getCalFilShop,
  click,
  inpage = "all",
  pageFilter = ["lakaUser", "MyShop", "all"],
  propsFIlter
}) => {
  const isOpen = show || filterShop;

  // Two ISOLATED systems share this drawer shell:
  //  * HISTORIC (buyer / sellerShop / sellerProducts): the original blocks below, rendered exactly as before --
  //    no Provider navigation, no Provider state, no extra wrapper.
  //  * PROVIDER / DROPSHIPPING IN ecosystem: "Elakay Navigation" (closed dropdowns) + the filters section the
  //    page registered for its context (drawerFilterSlot).
  // The context comes from route + page type + effective role permissions (filterContext.js).
  const { pathname, search } = useLocation();
  const filterContext = getFilterContext({ pathname, search, pageType: inpage, activeRole: getCurrentElakayRole(infoSource) });
  const ecosystem = isEcosystemContext(filterContext);
  const registered = useDrawerFilters();
  const pageFilters = ecosystem && registered && registered.context === filterContext ? registered : null;
  const navText = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.drawerNavigation || {};
  const filtersLabel = {
    [FILTER_CONTEXTS.DROPSHIPPING_IN]: navText.providerFilters || "Provider Filters",
    [FILTER_CONTEXTS.PROVIDER_SHOP]: navText.filtersShop || "Filters Shop",
    [FILTER_CONTEXTS.PROVIDER_PRODUCTS]: navText.filterProducts || "Filter Products",
  }[filterContext];

  // Card Display Mode (Portrait/Landscape) — Grid pages only. La préférence
  // est globale (localStorage) ; seules les pages Grid l'appliquent (voir
  // isGridPage dans Card.js / utils/cardDisplaySettings.js).
  const [cardMode, setCardMode] = useState(
    () => (typeof window !== 'undefined' && window.localStorage.getItem(CARD_MODE_STORAGE_KEY)) || 'portrait'
  );

  const changeCardMode = (mode) => {
    setCardMode(mode);
    window.localStorage.setItem(CARD_MODE_STORAGE_KEY, mode);
    window.dispatchEvent(new CustomEvent(CARD_MODE_EVENT, { detail: { mode } }));
  };

  // FILTERS button on a page: open this drawer AND bring the filters section into view.
  useEffect(() => {
    if (!isOpen || !consumeFilterFocus()) return undefined;
    const t = setTimeout(() => document.getElementById('drawer1-filters')?.scrollIntoView?.({ behavior: 'smooth', block: 'start' }), 120);
    return () => clearTimeout(t);
  }, [isOpen]);

  // Lock scroll on body and .elakayPage when drawer is open
  useEffect(() => {
    if (isOpen) {
      const elakayPage = document.querySelector('.elakayPage');
      const scrollY = elakayPage ? elakayPage.scrollTop : window.scrollY;
      
      // Save scroll position
      document.body.dataset.scrollY = scrollY;
      
      // Lock body and html
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      
      // Lock .elakayPage (main scrollable container)
      if (elakayPage) {
        elakayPage.style.overflow = 'hidden';
      }
    } else {
      const savedScrollY = parseInt(document.body.dataset.scrollY || '0');
      const elakayPage = document.querySelector('.elakayPage');
      
      // Restore body and html
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      
      // Restore .elakayPage
      if (elakayPage) {
        elakayPage.style.overflow = '';
        elakayPage.scrollTop = savedScrollY;
      }
    }

    return () => {
      const elakayPage = document.querySelector('.elakayPage');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (elakayPage) {
        elakayPage.style.overflow = '';
      }
    };
  }, [isOpen]);
const gridButon = () => {
    return <div className="card-mode-toggle m-2" role="group" aria-label={elakayAutoText("h_d9aa563cf7adb2", "Card display mode")}>
            <button
              type="button"
              className={`card-mode-btn ${cardMode === 'portrait' ? 'active' : ''}`}
              onClick={() => changeCardMode('portrait')}
            >
              <span aria-hidden="true">▦</span> {elakayAutoText("h_card_mode_portrait", "Portrait")}
            </button>
            <button
              type="button"
              className={`card-mode-btn ${cardMode === 'landscape' ? 'active' : ''}`}
              onClick={() => changeCardMode('landscape')}
            >
              <span aria-hidden="true">▤</span> {elakayAutoText("h_card_mode_landscape", "Landscape")}
            </button>
          </div>
}
  const drawerTree = (
    <>
      {/* Backdrop overlay */}
      <div
        className={`drawer1-backdrop ${isOpen ? 'visible' : ''}`}
        onClick={click}
        aria-hidden="true"
      />

      {/* Drawer */}
      <nav
        className={`side-drawer1 ${isOpen ? 'open' : ''}`}
        aria-hidden={!isOpen}
      >
        {/* Content */}
        <div className="drawer1-content">
          {ecosystem && <DrawerNavGroups infoSource={infoSource} click={click} resetKey={isOpen} displayMode={gridButon()} />}
          {ecosystem && pageFilters && <div id="drawer1-filters" className="drawer1-section-label drawer1-section-label--main">{filtersLabel}</div>}
          {ecosystem && pageFilters && (
            <div className="drawer1-page-filters" data-filter-context={filterContext}>{pageFilters.render({ click, embedded: true })}</div>
          )}
      {!ecosystem && <>

       {[inpage].includes("lakaUser") && userShop && (
            <FiltersSU
              infoSource={infoSource}
              getCalFilShop={getCalFilShop}
              handleFilters={handleFilters}
              setMyFilters={setMyFilters}
              gridButon={gridButon}
              click={click}
            />)}
        
           {[inpage].includes("all") &&(  <Filter
              infoSource={infoSource}
              AllCategorie={AllCategorie}
              SliderPunShow={SliderPunShow}
              categoryID={categoriesID}
              handleFilters={handleFilters}
              prices={prices}
              loadProductsBySell={loadProductsBySell}
              setMyFilters={setMyFilters}
              gridButon={gridButon}
              click={click}
            />)}


           {[inpage].includes("MyShop") && (  
            <div className="SideDrawer1-filters-container-modern SideDrawer1-myshop-container">
              <div className="SideDrawer1-filters-header">
                <div className="SideDrawer1-filters-header-content">
                  <div className="SideDrawer1-filters-icon-wrapper">
                    <MdInventory2 className="SideDrawer1-filters-icon" />
                  </div>
                  <div>
                    <span className="SideDrawer1-filters-eyebrow">ELAKAY</span>
                    <h3 className="SideDrawer1-filters-title">
                      {elakayAutoText("h_c8f73b98fa476d", "Filter Products")}
                    </h3>
                  </div>
                </div>
                <button type="button" className="SideDrawer1-filters-close-btn" onClick={click} aria-label={elakayAutoText("h_c2db1e0ed9c89b", "Close filters")}>
                  <MdClose />
                </button>
              </div>
              {gridButon()}
              <div className="SideDrawer1-filters-body SideDrawer1-myshop-body">
                <FilterUserProduct
                infoSource={infoSource}
                 {...propsFIlter}
                      />
              </div>
            </div>
           )}
      </>}
        </div>

        {/* Decorative elements */}
        <div className="drawer1-decoration" aria-hidden="true">
          <div className="deco-shape shape-1"></div>
          <div className="deco-shape shape-2"></div>
        </div>
      </nav>
    </>
  );

  // Provider / Dropshipping In pages: the drawer + its backdrop are mounted on <body>. Inside the Layout they sit
  // in the scrolling .elakayPage container, where the overlay was offset by the page scroll and stopped short of the
  // viewport bottom. Historic (Buyer / Seller) pages keep the original in-place rendering.
  return ecosystem && typeof document !== 'undefined' ? createPortal(drawerTree, document.body) : drawerTree;
};

export default SideDrawer1;
